import { EMPTY_CART_REQUEST, EMPTY_CART_SUCCESS, EMPTY_CART_ERROR, } from '../types';
import { useHelper } from '../helpers';
import { loadCart } from './load-cart';
export const emptyCartRequest = () => {
    return {
        type: EMPTY_CART_REQUEST,
    };
};
export const emptyCartSuccess = (cart) => {
    return {
        type: EMPTY_CART_SUCCESS,
        data: cart,
    };
};
export const emptyCartError = (error) => {
    return {
        type: EMPTY_CART_ERROR,
        error: true,
        payload: error,
    };
};
export const emptyCart = () => {
    return async (dispatch, getState, { chord }) => {
        const { withCart } = useHelper(dispatch, getState);
        try {
            dispatch(emptyCartRequest());
            await withCart(chord.oms.emptyOrder)(null);
            const updatedCart = await dispatch(loadCart());
            dispatch(emptyCartSuccess(updatedCart));
            return updatedCart;
        }
        catch (e) {
            dispatch(emptyCartError(e));
            throw e;
        }
    };
};
